import { render, staticRenderFns } from "./text-sign.vue?vue&type=template&id=2017e88b&scoped=true&"
import script from "./text-sign.vue?vue&type=script&lang=ts&"
export * from "./text-sign.vue?vue&type=script&lang=ts&"
import style0 from "./text-sign.vue?vue&type=style&index=0&id=2017e88b&lang=scss&scoped=true&"
import style1 from "./text-sign.vue?vue&type=style&index=1&id=2017e88b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2017e88b",
  null
  
)

export default component.exports